import { inheritsLoose as _inheritsLoose } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import propTypes from 'prop-types';

var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ErrorBoundary, _React$Component);

  ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
    console.log('getDerivedStateFromError', error);
    return {
      hasError: true
    };
  };

  function ErrorBoundary(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      hasError: false
    };
    return _this;
  }

  var _proto = ErrorBoundary.prototype;

  _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {
    console.error(error.message, errorInfo);
  };

  _proto.render = function render() {
    var hasError = this.state.hasError;
    var _this$props = this.props,
        children = _this$props.children,
        RenderError = _this$props.RenderError;

    if (hasError) {
      return /*#__PURE__*/React.createElement(RenderError, null);
    }

    return children;
  };

  return ErrorBoundary;
}(React.Component);

ErrorBoundary.defaultProps = {
  RenderError: function RenderError(error) {
    return "Hello! I am an error with the message: " + error.message;
  }
};
ErrorBoundary.propTypes = {
  children: propTypes.node,
  RenderError: propTypes.func
};

export { ErrorBoundary as default };
//# sourceMappingURL=index.js.map
